<template>
    <div class="tooltip-body__row report" @click.stop="userReport(true)">
        <BaseIcon :name="'conversation-report'" size="24"/>
        <p>{{ $t("Report") }}</p>
    </div>
</template>
<script>
import { eventBus } from '/webpack-assets/vue/utils/eventBus.js';
import BaseIcon from '/webpack-assets/vue/components/BaseIcon.vue';
    export default {
        components: {
            BaseIcon
        },
        data() {
            return {
                isShowModalReport: false,
            };
        },
        props: {
            userId: {
                type: String,
                default: null,
            },
            miniChat: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            eventBus.on('handle-close-modal-report', this.userReport(false));
        },
        beforeUnmount() {
            eventBus.off('handle-close-modal-report');
        },
        methods: {
            userReport(isOpen) {
                this.isShowModalReport = isOpen;
                eventBus.emit('handle-open-modal-report', { isOpen, userId: this.userId });
            },
        },
    };
  </script>

<style lang="scss" scoped>
.tooltip-body__row{
    cursor: pointer;
    &:hover{
        background: var(--wc-danger-soft);
    }
    svg{
        width: 16px;
        height: 16px;
        min-width: 16px;
        color: var(--wc-danger);
    }
    p{
        margin: 0;
        font-family: var(--wc-font);
        font-weight: 400;
        font-size: 13px;
        white-space: nowrap;
        line-height: 18px;
        color: var(--wc-danger);
    }
  }
</style>